module.exports = __webpack_public_path__ + "img/Vector@2x.63b392b9.png";